// extracted by mini-css-extract-plugin
module.exports = {"button":"NavigationButton_button__1Zc2S","linkWrapper":"NavigationButton_linkWrapper__3-N-P"};